import { Injectable } from '@angular/core';
import { TrxService } from '~services/trx/trx.service';

type ThanksTransactionDetails = {
  email: string;
  giftCardName: string;
  giftCardValue: string;
  categories: string[];
};

@Injectable()
export class ThanksScriptService {
  constructor(private trxService: TrxService) {}

  public async addThanksScript(transactionDetails: ThanksTransactionDetails) {
    // TODO: migrate gc_web_enable_thanks to Amplitude or remove it
    const isThanksEnabled = true;

    await this.trxService.sendExperimentEvent(
      `experiment_au_gift_cards_thanks_modal`,
      isThanksEnabled ? `gift_cards_thanks_modal_expb` : `gift_cards_thanks_modal_control`,
    );

    if (!isThanksEnabled) {
      return;
    }

    const thanks = {
      partnerId: 'ec72fc76-5eae-473d-8c8f-5035b0fbea77',
      statusText: 'Your giftcard is on its way!',
      customerLocation: {
        country: 'AU',
      },
      email: transactionDetails.email,
      items: [
        {
          name: transactionDetails.giftCardName,
          value: transactionDetails.giftCardValue,
          quantity: 1,
          currency: 'AUD',
          type: 'GiftCard',
        },
      ],
      onPersonalInformationRequest(_reason, _info) {
        return {
          email: transactionDetails.email,
        };
      },
    };

    window['__thanks'] = thanks;

    const tag = document.createElement('script');
    tag.src = 'https://s.thanks.is/v1/widget.js';
    document.head.appendChild(tag);
  }
}
